module.exports = __webpack_public_path__ + "img/ane-nogo-min.3e7b66ad.jpg";